// src/pages/AboutUs.jsx
import React from "react";
import { Container, Row, Col, Button, Accordion, Card } from "react-bootstrap";
// import aboutImg from "../assets/about-founder.jpg";
import "./AboutUs.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const AboutUs = () => {
  const faqLeft = [
    {
      question: "1. What is distance education?",
      answer:
        "Distance education allows students to pursue courses without being physically present on campus.",
    },
    {
      question: "2. Are the courses UGC-approved?",
      answer: "Yes, all courses offered are recognized and approved by UGC.",
    },
    {
      question: "3. Who is eligible for distance education programs?",
      answer:
        "Anyone who meets the eligibility criteria of the specific program can apply.",
    },
    {
      question: "4. How do I apply for a course?",
      answer:
        "You can apply online through the admission portal or visit our office.",
    },
    {
      question: "5. Is there any entrance exam required?",
      answer:
        "Some programs may require entrance tests, while others are merit-based.",
    },
  ];

  const faqRight = [
    {
      question: "6. Can I study while working full-time?",
      answer:
        "Yes, distance education is designed to provide flexibility for working professionals.",
    },
    {
      question: "7. Will I receive a valid degree certificate?",
      answer: "Yes, the degree awarded is valid and recognized across India.",
    },
    {
      question: "8. How are the classes conducted?",
      answer:
        "Classes are conducted through online lectures, study material, and recorded sessions.",
    },
    {
      question: "9. What documents are required for admission?",
      answer:
        "You will need ID proof, academic certificates, and passport-sized photographs.",
    },
    {
      question: "10. Is student support available during the course?",
      answer: "Yes, 24/7 student support is available through email and phone.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Distance Learning & Online Degree Courses in Bangalore</title>
        <meta
          name="description"
          content="Bangalore Distance Education offers flexible distance learning courses in Bangalore. Study anytime, anywhere with expert guidance."
        />
      </Helmet>

      <div className="about-us-page">
        {/* Hero Section */}

        <section className="about-section">
          <h2 className="about-title">ABOUT US</h2>

          <div className="about-cards">
            <div className="about-card">
              <h3 className="about-heading">We are</h3>
              <p>
                Bangalore Distance Education, a trusted platform connecting
                learners with UGC and AICTE-approved universities. We provide
                flexible, affordable, and career-focused programs designed to
                empower students across India.
              </p>
            </div>

            <div className="about-card active">
              <h3 className="about-heading">We believe</h3>
              <p>
                Education should be accessible to everyone—working
                professionals, parents, or fresh graduates. Our mission is to
                simplify higher education with flexible online learning tailored
                to real career growth.
              </p>
            </div>

            <div className="about-card">
              <h3 className="about-heading">We envision</h3>
              <p>
                A future where distance education breaks barriers, enabling
                learners to gain world-class knowledge, skills, and
                opportunities from home—building successful careers and
                contributing to India’s growth.
              </p>
            </div>
          </div>
        </section>

        <section className="video-about py-5">
          <Container>
            <Row className="align-items-center">
              {/* Left Content */}
              <Col md={6}>
                <p className="video-about-sub">ABOUT US</p>
                <h2 className="video-about-title">
                  Advance Your Career with Bangalore Distance Learning
                </h2>
                <p className="video-about-desc">
                  At Bangalore Distance Education, we believe learning should
                  fit into your life—not the other way around. That’s why we
                  bring you flexible, affordable, and trusted online and
                  distance education in Bangalore and beyond. In partnership
                  with UGC and AICTE-approved universities, we offer diplomas,
                  bachelor’s, master’s, and even PhD programs designed to match
                  your career goals. Whether you’re a working professional
                  aiming for a promotion, a parent balancing responsibilities,
                  or a student beginning your academic journey, we make higher
                  education accessible anytime, anywhere. With supportive
                  guidance and career-focused courses, we’re here to help you
                  grow, achieve, and succeed.
                </p>
              </Col>

              {/* Right Creative Image */}
              <Col md={6} className="text-center">
                <div>
                  <img
                    src="/images/about.png"
                    alt="Enthusiastic Bangalore distance education students celebrating online learning success"
                    // className="video-img"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Our Story */}

        <div className="ceo-section">
          <Container fluid>
            <Row className="align-items-center">
              {/* Left Side - CEO Image */}
              <Col md={6} className="text-center">
                <img
                  src="/images/founder.webp"
                  alt="Dr. Sarita Nair, CEO of Bangalore distance education
"
                  className="ceo-img"
                />
              </Col>

              {/* Right Side - Content */}
              <Col md={6} className="ceo-content">
                <div className="green-bar"></div>
                <h2 className="ceo-title">Meet Our CEO</h2>
                <h5 className="ceo-name">Dr. Sarita Nair</h5>
                <p className="ceo-text">
                  Having dealt with all problems herself, Sarita decided to do
                  something for the housewives who usually forget to live while
                  taking care of their family and loved ones . Her motivation
                  were differently-abled seniors in her field doing excellent
                  service for disabled communities. Sarita started Bangalore
                  Distance education back in 1990 out of a garage, an
                  organization dedicated to help individuals who have given up
                  their career goals for family to lead dignified lives. Her
                  family was apparently worried and guarded initially when she
                  revealed her preferences to get into this line of assignment.
                  They didn’t initially acknowledge in her abilities to perform
                  what she desired, but as time progressed and she started
                  getting results, they trusted more in what she could reach.
                  “People who see femininity as a disability should glance at us
                  and acknowledge that everybody in this world is equally
                  capable.” she proudly says.
                </p>

                {/* Circles */}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
